<template>
    <div>
        <div v-for="guess in guesses">{{guess}}</div>
    </div>
</template>

<script>
    import NameValue from "../../NameValue";
    import {mapGetters} from "vuex";

    export default {
        components: {NameValue},
        computed: {
            ...mapGetters(['allPosts']),
            guesses() {
                let res = [];

                // TODO check the title of submissions too
                let subGuess = [
                    {matches: ['the_donald'], result: [{min: 10, value: 'Trump Supporter'}]},
                    {matches: ['movies'], result: [{min: 5, value: 'Likes movies'}, {min: 40, value: 'Cinephile'}]},
                    {matches: ['android', 'androidgaming'], result: [{min: 5, value: 'Prefers Android phones'}]},
                    {matches: ['apple'], result: [{min: 3, value: 'Likes Apple products'}]},
                    {
                        matches: ['webdev', 'programmerhumor', 'programming', 'python', 'reactjs'],
                        result: [{min: 10, value: 'Programmer'}]
                    },
                    {matches: ['trees'], result: [{min: 3, value: 'Likes Trees'}]},
                    {
                        matches: ['buildapc', 'masterrace', 'battlestations'],
                        result: [{min: 10, value: 'PC Enthusiast'}]
                    },
                    {matches: ['books'], result: [{min: 3, value: 'Likes to read'}]},
                    {matches: ['nosleep'], result: [{min: 3, value: 'Nosleep Reader'}]},
                    {
                        matches: ['photography', 'photocritique', 'itookapicture'],
                        result: [{min: 10, value: 'Photograpy Enthusiast'}]
                    },
                    {matches: ['drawing', 'painting'], result: [{min: 10, value: 'Drawing Enthusiast'}]},
                    {matches: ['yoga'], result: [{min: 3, value: 'Into Yoga'}]},
                ];

                subGuess.forEach(g => {
                    let count = this.allPosts.map(d => d.data)
                        .filter(d => g.matches.includes(d.subreddit.toLowerCase()))
                        .reduce((a, c) => a + 1, 0);

                    if (count > 0) {
                        let val = g.result.reduce((a, c) => {
                            if (c.min < count)
                                return c.value;
                            else
                                return a;
                        }, null);

                        if (val)
                            res.push(val);
                    }
                });

                return res;
            }
        }
    }
</script>

<style scoped>

</style>
